(() => {
  const GIFT_VARIANT_ID = 39566638809279;

  const THRESHOLDS = {
    USD: 25000, // $250
    CAD: 30000  // $300 CAD
  };

const SALE_START = new Date('2026-10-19T04:00:00Z');
const SALE_END   = new Date('2026-10-24T19:00:00Z');

  let updatingGift = false;

  function saleIsActive() {
  const now = new Date();
  return now >= SALE_START && now < SALE_END;
}

  async function getCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Unable to load cart');
    }

    return response.json();
  }

  function getCurrency(cart) {
    return cart.currency || window.Shopify?.currency?.active || 'USD';
  }

  function findGift(cart) {
    return cart.items.find(item =>
      Number(item.variant_id) === Number(GIFT_VARIANT_ID) &&
      item.properties &&
      item.properties._anniversary_gift === 'true'
    );
  }

  function qualifyingTotal(cart) {
    let total = cart.total_price;

    const gift = findGift(cart);

    // Always exclude the gift line from qualification.
    // Even if Appstle temporarily shows it at full price during recalculation.
    if (gift) {
      total -= gift.final_line_price;
    }

    return Math.max(total, 0);
  }

  async function addGift() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: {
            '_anniversary_gift': 'true'
          }
        }]
      })
    });

    if (!response.ok) {
      throw new Error('Unable to add anniversary gift');
    }
  }

  async function removeGift(gift) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: gift.key,
        quantity: 0
      })
    });

    if (!response.ok) {
      throw new Error('Unable to remove anniversary gift');
    }
  }

  async function enforceGiftQuantity(gift) {
    if (!gift || gift.quantity === 1) return;

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: gift.key,
        quantity: 1
      })
    });

    if (!response.ok) {
      throw new Error('Unable to reset anniversary gift quantity');
    }
  }

  function refreshCart() {
    document.dispatchEvent(
      new CustomEvent('cart:refresh')
    );
  }

  async function updateAnniversaryGift() {
    if (updatingGift) return;

    updatingGift = true;

    try {
      const cart = await getCart();
      const gift = findGift(cart);

      const currency = getCurrency(cart);
      const threshold = THRESHOLDS[currency];

      if (!saleIsActive() || !threshold) {
        if (gift) {
          await removeGift(gift);
          refreshCart();
        }

        return;
      }

      const total = qualifyingTotal(cart);
      const qualifies = total >= threshold;

      // Customer qualifies but gift isn't in cart yet
      if (qualifies && !gift) {
        await addGift();

        await new Promise(resolve =>
          setTimeout(resolve, 500)
        );

        refreshCart();
        return;
      }

      // Customer no longer qualifies
      if (!qualifies && gift) {
        await removeGift(gift);

        await new Promise(resolve =>
          setTimeout(resolve, 400)
        );

        refreshCart();
        return;
      }

      // Keep the automatically-added gift at quantity 1
      if (qualifies && gift && gift.quantity !== 1) {
        await enforceGiftQuantity(gift);

        await new Promise(resolve =>
          setTimeout(resolve, 400)
        );

        refreshCart();
      }

    } catch (error) {
      console.error(
        'Anniversary gift error:',
        error
      );
    } finally {
      updatingGift = false;
    }
  }

  document.addEventListener(
    'DOMContentLoaded',
    updateAnniversaryGift
  );

  document.addEventListener(
    'cart:refresh',
    () => {
      setTimeout(updateAnniversaryGift, 500);
    }
  );

  const originalFetch = window.fetch;

  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);

    const url =
      typeof args[0] === 'string'
        ? args[0]
        : args[0]?.url || '';

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update')
    ) {
      setTimeout(updateAnniversaryGift, 500);
    }

    return response;
  };
})();